<div class="page">
  <form [formGroup]="form" class="config-form">
    <!-- ========================================== -->
    <!-- DATOS DE LA CLÍNICA -->
    <!-- ========================================== -->

    <section class="section-card">
      <h2>Redes sociales</h2>

      <p>
        Se muestran en el pie de la receta. Para agregarlas o editarlas, ve a "Editar institución".
      </p>

      <mat-slide-toggle formControlName="mostrarRedes">
        Mostrar redes sociales en la receta
      </mat-slide-toggle>

      <div class="redes-lista">
        @if (cargandoRedes) {
          <p>Cargando redes sociales…</p>
        } @else if (redesClinica.length === 0) {
          <p class="sin-datos">La institución aún no tiene redes sociales registradas.</p>
        } @else {
          @for (red of redesClinica; track red.id) {
            <div class="red-item">
              <mat-icon class="material-symbols-outlined">alternate_email</mat-icon>
              <strong>{{ red.redSocial }}</strong>
              <span>{{ red.usuario }}</span>
            </div>
          }
        }
      </div>
    </section>

    <!-- ========================================== -->
    <!-- COLORES Y DISPOSICIÓN -->
    <!-- ========================================== -->

    <section class="section-card">
      <h2>Colores y disposición</h2>

      <div class="form-grid">
        <div class="color-field">
          <label>Color principal</label>
          <input type="color" formControlName="colorPrincipal" />
        </div>

        <div class="color-field">
          <label>Color de texto</label>
          <input type="color" formControlName="colorTexto" />
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Diseño de la receta</mat-label>
          <mat-select formControlName="disposicion">
            <mat-option value="clasico">Clásico</mat-option>
            <mat-option value="moderno">Moderno</mat-option>
            <mat-option value="nueva">Diseño 3</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="section-card">
      <h2>Logo institucional</h2>

      <div class="logo-clinica-info">
        <div class="logo-clinica-preview">
          @if (cargandoLogo) {
            <mat-icon>hourglass_empty</mat-icon>
            <p>Cargando logo…</p>
          } @else if (logoInstitucion) {
            <img [src]="logoInstitucion" alt="Logo de la institución" class="logo-preview-receta" />
          } @else {
            <mat-icon>business</mat-icon>
            <p>No hay logo configurado.</p>
          }
        </div>

        <div class="logo-clinica-descripcion">
          <strong>Este logo se usa en la receta</strong>
          <p>
            Se muestra como logo del encabezado (si activas "Mostrar logo") y como marca de agua (si
            activas "Mostrar marca de agua"). Para cambiarlo, ve a "Editar institución de salud".
          </p>
        </div>
      </div>

      <mat-slide-toggle class="slide" formControlName="mostrarLogo">
        Mostrar logo en el encabezado
      </mat-slide-toggle>
    </section>

    <section class="section-card">
      <h2>Marca de agua</h2>

      <p>
        Si hay un logo institucional configurado, se usará como marca de agua. Si no hay logo, se
        usará el texto de respaldo definido abajo.
      </p>

      <mat-slide-toggle formControlName="mostrarMarcaAgua">
        Mostrar marca de agua
      </mat-slide-toggle>

      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Texto de respaldo (sin logo)</mat-label>
          <input matInput formControlName="textoMarcaAgua" />
        </mat-form-field>

        <div class="color-field">
          <label>Color (texto de respaldo)</label>
          <input type="color" formControlName="colorMarcaAgua" />
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Opacidad (0 a 1)</mat-label>
          <input
            matInput
            type="number"
            step="0.1"
            min="0"
            max="1"
            formControlName="opacidadMarcaAgua"
          />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Ángulo (grados, solo texto de respaldo)</mat-label>
          <input matInput type="number" formControlName="anguloMarcaAgua" />
        </mat-form-field>
      </div>
    </section>

    <!-- ========================================== -->
    <!-- ACCIONES -->
    <!-- ========================================== -->

    <div class="acciones">
      <button mat-flat-button class="add-boton" type="button" (click)="restaurarPredeterminada()">
        <mat-icon>restore</mat-icon>
        Restaurar predeterminado
      </button>

      <button mat-flat-button class="add-boton" type="button" (click)="vistaPrevia()">
        <mat-icon>visibility</mat-icon>
        Vista previa
      </button>

      <!-- <button mat-flat-button type="button" class="add-boton" (click)="vistaPreviaRecetaNueva()">
        Vista previa (nueva receta)
      </button> -->

      <button mat-flat-button class="add-boton" type="button" (click)="guardar()">
        <mat-icon>save</mat-icon>
        Guardar configuración
      </button>
    </div>
  </form>
</div>
